import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ColumnUnits, UnitsFormattersService} from '../../units-formatters/units-formatters.service';
import {Column} from 'asax-common';
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

const timeout = 300;

@Component({
  selector: 'asax-result-table-search-table-cell-container',
  templateUrl: './cell-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellContainerComponent implements OnInit {
  @ViewChild('cellText', {static: false}) cellTextElementRef: ElementRef;
  @ViewChild('tooltip', {static: false}) tooltip: NgbTooltip;

  @Input() row: any;
  @Input() value: any;
  @Input() column: Column;

  columnUnitsObservable: Observable<ColumnUnits>;

  private timeout: NodeJS.Timeout;

  constructor(private readonly unitsFormattersService: UnitsFormattersService) {
  }

  ngOnInit(): void {
    this.columnUnitsObservable = this.unitsFormattersService.getColumnsUnits().pipe(
      map(columnsUnits => columnsUnits?.find(columnUnits => columnUnits.columnId === this.column.id)),
      filter(columnUnits => !!columnUnits),
      distinctUntilChanged()
    );
  }

  openWithTimeout() {
    if (this.cellTextElementRef?.nativeElement?.scrollWidth > this.cellTextElementRef?.nativeElement?.offsetWidth) {
      this.clearTimeout();
      this.timeout = setTimeout(() => this.tooltip?.open(), timeout);
    }
  }

  closeWithTimeout() {
    this.clearTimeout();
    this.timeout = setTimeout(() => this.tooltip.close(), timeout);
  }

  clearTimeout() {
    clearTimeout(this.timeout);
  }
}
